module.exports = __webpack_public_path__ + "media/reskin-images/icon--select-chevron-72adfa38.svg";